import { useState } from 'react';
import dayjs from 'dayjs';
import { AmountUtils } from '@shared/utils';
import type { GetTransactionsResponse } from '@shared/api';
import { PaymentsPrintableContent } from './paymentsPrintableContent';
import { Button, Modal, PrintableContent, PrintStyle, PrintType } from '@shared/widgets';
import PrintIcon from '@assets/icons/print2.svg';

interface PrintInfoModalProps {
  isOpen: boolean;
  transaction?: GetTransactionsResponse;
  onClose: () => void;
}

export interface TransactionDataType {
  label: string;
  value?: string;
}

export const PrintInfoModal = (props: PrintInfoModalProps) => {
  const [viewPrintVersion, setViewPrintVersion] = useState<boolean>(false);

  const transactionData: TransactionDataType[] = [
    ...(props.transaction?.Requisites
      ? [
          { label: 'Owner name', value: props.transaction.Requisites.OwnerName },
          { label: 'Bank name', value: props.transaction.Requisites.BankName },
          { label: 'Bank address', value: props.transaction.Requisites.BankAddress },
          { label: 'Bic', value: props.transaction.Requisites.BIC },
          { label: 'Iban', value: props.transaction.Requisites.IBAN },
        ]
      : [{ label: 'Credit Account', value: props.transaction?.Beneficiary }]),
    {
      label: 'Amount',
      value: `${props.transaction?.Currency} ${AmountUtils.transformToAmount(props.transaction?.PaidOut ?? 0)}`,
    },
    { label: 'Debit Account', value: props.transaction?.Account },
    {
      label: 'Date',
      value: dayjs(props.transaction?.Date).format('DD/MM/YYYY'),
    },
  ];

  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose} title={props.transaction?.Description}>
      <div className='w-full'>
        <div className='mt-4.5 mb-6.5 flex flex-col gap-4'>
          {transactionData.map((item, index) => (
            <div key={index} className='flex flex-col gap-1'>
              <div className='text-xs font-semibold text-[#929292] uppercase'>{item.label}</div>
              <div className='text-sm font-medium text-[#fcfcfc] uppercase'>{item.value}</div>
            </div>
          ))}
        </div>
        <div className='flex flex-col gap-6.5'>
          <Button className='gap-2.5' fullWidth onClick={() => setViewPrintVersion(true)}>
            <PrintIcon />
            Print
          </Button>
          <Button fullWidth color='outlined' onClick={props.onClose}>
            Cancel
          </Button>
        </div>
      </div>
      <PrintableContent
        title='fds'
        print={viewPrintVersion}
        printStyle={PrintStyle.getStyle(PrintType.Table)}
        onAfterPrint={() => setViewPrintVersion(false)}
      >
        <PaymentsPrintableContent transaction={transactionData} title={props.transaction?.Description} />
      </PrintableContent>
    </Modal>
  );
};
